import { PaymentDetailsReportViewModel } from '../../../../common/model/payment/paymentDetailsReportResponse';
import { createDataFetchSlice } from '../../../utils/dataFetch';


export const adminReportsPaymentDetailsSlice = createDataFetchSlice<
    PaymentDetailsReportViewModel
>({ name: 'paymentDetails' });
